<template>
  <svg
      viewBox="0 0 22 27"
      xmlns="http://www.w3.org/2000/svg"
  >
    <path
        :style="`fill:${accentColor}`"
        d="M19.71,2a.29.29,0,0,1,.29.29h0V24.71a.29.29,0,0,1-.29.29H2.29A.29.29,0,0,1,2,24.71H2V2.29A.29.29,0,0,1,2.29,2H19.71m0-2H2.29A2.28,2.28,0,0,0,0,2.27V24.71A2.3,2.3,0,0,0,2.29,27H19.71A2.3,2.3,0,0,0,22,24.71h0V2.29A2.28,2.28,0,0,0,19.73,0Z"
        transform="translate(0 0)"
    />
    <line
        :style="`fill:none;stroke:${accentColor};stroke-linecap:round;stroke-linejoin:round;stroke-width:2px`"
        x1="6"
        x2="16"
        y1="6"
        y2="6"
    />
    <line
        :style="`fill:none;stroke:${accentColor};stroke-linecap:round;stroke-linejoin:round;stroke-width:2px`"
        x1="6"
        x2="16"
        y1="11"
        y2="11"
    />
    <line
        :style="`fill:none;stroke:${accentColor};stroke-linecap:round;stroke-linejoin:round;stroke-width:2px`"
        x1="6"
        x2="16"
        y1="16"
        y2="16"
    />
    <line
        :style="`fill:none;stroke:${accentColor};stroke-linecap:round;stroke-linejoin:round;stroke-width:2px`"
        x1="6"
        x2="16"
        y1="21"
        y2="21"
    />
  </svg>
</template>

<script>
export default {
  name: "FileIcon",
  data() {
    return {
      accentColor: null,
    }
  },
  mounted() {
    this.accentColor = this.$vuetify.theme.themes.light.secondary
  },
}
</script>

<style>

</style>